import React from 'react';
import { Control } from 'react-hook-form';

import { InputAdornment } from '@mui/material';
import { LbInput, InputView } from '@infoods/lifebase-ui';

import { CoachSeatsFormValues } from '../../../interfaces/coachSeats';
import { Mode } from '../../../../general-types';
import {
  validateNegativeNumber,
  validateOnlyInteger,
} from '../../../../shared/utils/reactHookFormUtils';
import { getIsNullish } from '../../../../shared/utils/jsUtils';
import { useUserRoleLabel } from '../../../../shared/hooks/useUserRoleLabel';

type CoachSeatsInputProps = {
  control: Control<CoachSeatsFormValues>;
  mode: Mode;
  usedSeats?: number;
  coachSeats?: number;
};

const CoachSeatsInput = ({
  control,
  mode,
  usedSeats = 0,
  coachSeats,
}: CoachSeatsInputProps) => {
  const { getForAgent } = useUserRoleLabel();

  if (mode === 'VIEW') {
    const inputValue = getIsNullish(coachSeats)
      ? 'Not set'
      : `${usedSeats}/${coachSeats} seats`;

    return (
      <InputView
        valueClassName="private-info"
        value={inputValue}
        label="Available Seats"
      />
    );
  }

  return (
    <LbInput
      variant="outlined"
      control={control}
      name="coachSeats"
      type="number"
      size="small"
      rules={{
        required: `${getForAgent()} Seats is required`,
        validate: {
          validateOnlyInteger,
          validateNegativeNumber,
        },
      }}
      InputProps={{
        endAdornment: <InputAdornment position="end">seats</InputAdornment>,
      }}
    />
  );
};

export { CoachSeatsInput };
